const sum = (items) => items.reduce((sum, current) => (sum += current), 0);

export default sum;
